import { TPartials } from '../useGetProcessedValues.hook';
import { getHolesTotal } from './getHolesTotal';

export type TProcessValues = (
  stablefords: string[],
  start: number,
  end: number,
  partials: TPartials
) => string[];

export const processValues: TProcessValues = (values, start, end, partials) =>
  (values || [])
    .slice(start, end)
    .map(h => String(h))
    .reduce((acc: string[], hole: string, index: number) => {
      const totals = partials.filter(p => p.to === index + start).map(getHolesTotal(values));

      return totals ? [...acc, hole].concat(totals.map(t => String(t))) : [...acc, hole];
    }, []);
